/**
 * Local mirror of `PUBLIC_SHOW_FLAG_KEYS` from `@orbit/api-types`.
 *
 * Duplicated on purpose: `@orbit/api-types` builds its Zod schemas from
 * `@orbit/models` (Prisma), so importing any runtime *value* from it drags the
 * Prisma runtime into the browser bundle. The webapp needs only these six keys,
 * and `__tests__/shareFlags.contract.test.ts` pins them to the api-types source
 * of truth so a new or renamed flag can never drift between the two.
 */
export const PUBLIC_SHOW_FLAG_KEYS = {
	publicShowItinerary: true,
	publicShowIdeas: true,
	publicShowAccommodations: true,
	publicShowFlights: true,
	publicShowFiles: true,
	publicShowExpenses: true,
} as const

/**
 * The flags a trip owner may actually toggle in the Sharing UI. `publicShowFiles`
 * and `publicShowExpenses` are deliberately excluded: files exposes every file
 * (passports, receipts, boarding passes) and expenses publishes named balances
 * and pay ups, so both are marketing-only surfaces enabled directly on curated
 * demo trips, never user-controllable (ADR 0003). The backend rejects any attempt
 * to set them. Kept as a separate map (rather than dropping the keys outright) so
 * `PUBLIC_SHOW_FLAG_KEYS` stays the full wire contract that keeps every flag off
 * the shared Trip model.
 */
export const TOGGLEABLE_SHOW_FLAG_KEYS = {
	publicShowItinerary: true,
	publicShowIdeas: true,
	publicShowAccommodations: true,
	publicShowFlights: true,
} as const
